// Exposure remains centralized so Refer & Earn can be suspended without deleting code or data.
export const REFER_AND_EARN_ENABLED = true;
